import React from "react";
import "./App.css";

import CheckoutProcess from "./components/CheckoutProcess/CheckoutProcess";

function App() {
  // var qs = require("qs");
  // let checkoutId = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  //   .checkoutID;

  return (
    <div className="App">
      <CheckoutProcess />
    </div>
  );
}

export default App;
